export function downloadCSV(rows, filename) {
  if (!rows.length) return;
  const headers = Object.keys(rows[0]);
  const csv = [
    headers.join(','),
    ...rows.map(row =>
      headers.map(h => {
        const val = row[h];
        if (val == null) return '';
        const str = String(val);
        return str.includes(',') || str.includes('"') || str.includes('\n')
          ? `"${str.replace(/"/g, '""')}"` : str;
      }).join(',')
    )
  ].join('\n');

  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

export function formatDailyExport(outlets, date) {
  return outlets.filter(o => o.has_entry).map(o => {
    // Canonical totals include Room Revenue + Room Budget.
    const totalSales = (o.total_revenue != null) ? o.total_revenue
                        : ((o.net_sales || 0) + (o.room_revenue || 0));
    const totalBudget = (o.total_budget != null) ? o.total_budget
                        : ((o.budget || 0) + (o.room_revenue_budget || 0));
    return {
      'Date': date,
      'Outlet': o.outlet_name,
      'Total Sales (incl. Rooms)': totalSales,
      'Total Budget (incl. Rooms)': totalBudget,
      'Variance': o.variance != null ? o.variance : (totalSales - totalBudget),
      'Variance %': o.variance_pct || 0,
      'F&B Net Sales': o.net_sales || 0,
      'F&B Budget': o.budget || 0,
      'Room Revenue': o.room_revenue || 0,
      'Room Budget': o.room_revenue_budget || 0,
      'Food Sale': o.food_sale || 0,
      'Beverage Sale': o.beverage_sale || 0,
      'Food Cost %': o.food_cost_pct || 0,
      'Bev Cost %': o.beverage_cost_pct || 0,
      'Dine-in': o.channel_dine_in || 0,
      'Swiggy': o.channel_swiggy || 0,
      'Zomato': o.channel_zomato || 0,
      'Other Channel': o.channel_other || 0,
      'LY Same Day Sales': o.last_year_net_sales ?? '',
    };
  });
}

export function formatMTDExport(outlets, month) {
  return outlets.map(o => {
    const yoy = o.ly_total_sales != null && o.ly_total_sales > 0
      ? ((o.total_sales - o.ly_total_sales) / o.ly_total_sales * 100).toFixed(1)
      : '';
    // Canonical grand totals for the reporting period.
    const totalSales = (o.total_revenue != null) ? o.total_revenue
                        : ((o.total_sales || 0) + (o.total_room_revenue || 0));
    const totalBudget = (o.total_budget || 0) + (o.total_room_budget || 0);
    return {
      'Month': month,
      'Outlet': o.outlet_name,
      'Total Sales (incl. Rooms)': totalSales,
      'Total Budget (incl. Rooms)': totalBudget,
      'Variance': totalSales - totalBudget,
      'Variance %': totalBudget > 0 ? Number(((totalSales - totalBudget) / totalBudget * 100).toFixed(1)) : 0,
      'F&B Sales': o.total_sales || 0,
      'F&B Budget': o.total_budget || 0,
      'Room Revenue': o.total_room_revenue || 0,
      'Room Budget': o.total_room_budget || 0,
      'LY Same Month Sales': o.ly_total_sales ?? '',
      'YoY Change %': yoy,
      'Avg Daily Sales': o.avg_daily_sales || 0,
      'Food Cost %': o.avg_food_cost_pct || 0,
      'Bev Cost %': o.avg_beverage_cost_pct || 0,
      'Days Reported': o.days_reported || 0,
      'LY Days Reported': o.ly_days_reported || 0,
    };
  });
}

export function formatEntryExport(entries) {
  return entries.map(e => {
    const c = e.calculated || {};
    return {
      'Date': e.date,
      'Budget': e.budget || 0,
      'Gross Sales': e.gross_sales || 0,
      'Discount': e.discount || 0,
      'Net Sales': c.net_sales || 0,
      'Food Sale': e.food_sale || 0,
      'Beverage Sale': e.beverage_sale || 0,
      'Food Cost': c.food_cost || 0,
      'Food Cost %': c.food_cost_pct || 0,
      'Bev Cost': c.beverage_cost || 0,
      'Bev Cost %': c.beverage_cost_pct || 0,
      'Variance': c.variance || 0,
      'Variance %': c.variance_pct || 0,
      'Dine-in': e.channel_dine_in || 0,
      'Swiggy': e.channel_swiggy || 0,
      'Zomato': e.channel_zomato || 0,
      'Other Channel': e.channel_other || 0,
      'Kitchen Issues': e.kitchen_issues || 0,
      'Bar Issues': e.bar_issues || 0,
      'HK Issues': e.hk_issues || 0,
      'Other Purchases': e.other_purchases || 0,
      'Avg Rating': e.avg_rating_day || 0,
      'Reviews': e.direct_reviews || 0,
      'Remarks': e.remarks || '',
    };
  });
}
